import {
    LICENCE_CATEGORY,
    OTHER_DETAILS,
    FOREIGN_COMPANY_DETAILS,
    OPERATING_LOCATION,
    STATION_EQUIPMENT_INFORMATION,
    TRIAL_INFORMATION,
    SUPPORTING_DOCUMENTS
} from '../../../../common/application.const/Licence/MyApplication/TFApplication';
import {
    LICENCE_DETAILS,
    SUPPORTING_DOCUMENTS as CANCEL_SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyApplication/cancelLicence';
import { SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatTFApplication = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    let operatingLocation = [];

    newDocs = [];

    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    for (const key in licenceDetails.supportingDocuments) {
        if (licenceDetails.supportingDocuments.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.supportingDocuments[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (licenceDetails && licenceDetails.operatingAddressInformation && licenceDetails.operatingAddressInformation.length > 0) {
        operatingLocation = licenceDetails?.operatingAddressInformation.map((value: any, i: number) => ({
            no: value?.rowId ?? '-',
            'building-name': value?.address?.buildingName ?? '-',
            'street-name': value?.address?.streetName ?? '-',
            'block-house-no': value?.address?.blockNo ?? '-',
            'floor-level': value?.address?.floor ?? '-',
            unit: value?.address?.unit ?? '-',
            'postal-code': value?.address?.postalCode ?? '-'
        }));
    }

    licence = {
        id: 'technical-trial-without-use-of-frequency',
        formID: 'technical-trial-without-use-of-frequency',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${LICENCE_CATEGORY}-licence-category`]: licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',

            [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${FOREIGN_COMPANY_DETAILS}-foreign-company-name`]: licenceDetails?.organisationInformation?.companyName ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-1`]: licenceDetails?.organisationInformation?.address?.foreignAddress1 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-2`]: licenceDetails?.organisationInformation?.address?.foreignAddress2 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-3`]: licenceDetails?.organisationInformation?.address?.foreignAddress3 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-4`]: licenceDetails?.organisationInformation?.address?.foreignAddress4 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-address-line-5`]: licenceDetails?.organisationInformation?.address?.foreignAddress5 ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-email`]: licenceDetails?.organisationInformation?.email ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-contact-number`]: licenceDetails?.organisationInformation?.telNumber ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-city`]: licenceDetails?.organisationInformation?.address?.city ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-state`]: licenceDetails?.organisationInformation?.address?.state ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-zip-code`]: licenceDetails?.organisationInformation?.address?.zipCode ?? '-',
            [`${FOREIGN_COMPANY_DETAILS}-country`]: licenceDetails?.organisationInformation?.address?.country ?? '-',

            [`${OPERATING_LOCATION}-list`]: operatingLocation ?? [...operatingLocation],

            [`${STATION_EQUIPMENT_INFORMATION}-start-date`]: licenceDetails?.StationInformationPage?.periodStartDate ?? '-',
            [`${STATION_EQUIPMENT_INFORMATION}-end-date`]: licenceDetails?.StationInformationPage?.periodEndDate ?? '-',
            [`${STATION_EQUIPMENT_INFORMATION}-station-equipment-name`]: licenceDetails?.StationInformationPage?.stationName ?? '-',
            [`${STATION_EQUIPMENT_INFORMATION}-purpose-and-objectives`]:
                licenceDetails?.StationInformationPage?.purposeAndObjectives ?? '-',

            [`${TRIAL_INFORMATION}-please-state-if-you-hold-radiocommunication-licences-issued-by-imda`]:
                licenceDetails?.trialInformation?.pleaseStateIfYouHoldAnyRadiocommunicationLicencesIssuedByImda ?? '-',
            [`${TRIAL_INFORMATION}-objective-of-the-proposed-trial`]: licenceDetails?.trialInformation?.objectiveOfTheProposedTrial ?? '-',
            [`${TRIAL_INFORMATION}-date-and-period-duration-of-the-proposed-trial`]:
                licenceDetails?.trialInformation?.dateAndPeriodDurationOfTheProposedTrial ?? '-',
            [`${TRIAL_INFORMATION}-describe-the-role-identity-and-numbers-of-involved-parties`]:
                licenceDetails?.trialInformation?.describeTheRoleIdentityAndNumberOfInvolvedParties ?? '-',
            [`${TRIAL_INFORMATION}-describe-the-scope-and-feature-with-the-technical-commercial-parameters`]:
                licenceDetails?.trialInformation?.describeTheScopeAndFeatureWithTheTechnicalCommercialParameters ?? '-',
            [`${TRIAL_INFORMATION}-provide-the-system-configuration-that-will-be-used`]:
                licenceDetails?.trialInformation?.provideTheSystemConfigurationThatWillBeUsed ?? '-',
            [`${TRIAL_INFORMATION}-provide-the-location-and-geographic-coverage`]:
                licenceDetails?.trialInformation?.provideTheLocationAndGeographicCoverage ?? '-',

            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${CANCEL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {
        const mapped = (
            licenceDetails?.iwantToAmend ||
            licenceDetails?.licenceDetails?.iwantToAmend ||
            licenceDetails?.iWantToUpdate ||
            licenceDetails?.licenceDetails?.iWantToUpdate
        )?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-technical-trial-without-use-of-frequency',
            formID: 'amend-technical-trial-without-use-of-frequency',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_CATEGORY}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],
                [`${LICENCE_CATEGORY}-licence-category`]:
                    licenceDetails?.LicenceCategoryDetails?.pleaseSelectTheLicenceYouWishToApply ?? '-',

                [`${OTHER_DETAILS}-proposed-used-of-system`]: licenceDetails?.otherDetails?.proposedUseOfSystemEquipment ?? '-',
                [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

                [`${FOREIGN_COMPANY_DETAILS}-foreign-company-name`]: licenceDetails?.organisationInformation?.companyName ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-address-line-1`]: licenceDetails?.organisationInformation?.address?.foreignAddress1 ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-address-line-2`]: licenceDetails?.organisationInformation?.address?.foreignAddress2 ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-address-line-3`]: licenceDetails?.organisationInformation?.address?.foreignAddress3 ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-address-line-4`]: licenceDetails?.organisationInformation?.address?.foreignAddress4 ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-address-line-5`]: licenceDetails?.organisationInformation?.address?.foreignAddress5 ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-email`]: licenceDetails?.organisationInformation?.email ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-contact-number`]: licenceDetails?.organisationInformation?.telNumber ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-city`]: licenceDetails?.organisationInformation?.address?.city ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-state`]: licenceDetails?.organisationInformation?.address?.state ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-zip-code`]: licenceDetails?.organisationInformation?.address?.zipCode ?? '-',
                [`${FOREIGN_COMPANY_DETAILS}-country`]: licenceDetails?.organisationInformation?.address?.country ?? '-',

                [`${OPERATING_LOCATION}-list`]: operatingLocation ?? [...operatingLocation],

                [`${STATION_EQUIPMENT_INFORMATION}-start-date`]: licenceDetails?.StationInformationPage?.periodStartDate ?? '-',
                [`${STATION_EQUIPMENT_INFORMATION}-end-date`]: licenceDetails?.StationInformationPage?.periodEndDate ?? '-',
                [`${STATION_EQUIPMENT_INFORMATION}-station-equipment-name`]: licenceDetails?.StationInformationPage?.remarks ?? '-', // tbd
                [`${STATION_EQUIPMENT_INFORMATION}-purpose-and-objectives`]:
                    licenceDetails?.StationInformationPage?.purposeAndObjectives ?? '-',

                [`${TRIAL_INFORMATION}-please-state-if-you-hold-radiocommunication-licences-issued-by-imda`]:
                    licenceDetails?.trialInformation?.pleaseStateIfYouHoldAnyRadiocommunicationLicencesIssuedByImda ?? '-',
                [`${TRIAL_INFORMATION}-objective-of-the-proposed-trial`]:
                    licenceDetails?.trialInformation?.objectiveOfTheProposedTrial ?? '-',
                [`${TRIAL_INFORMATION}-date-and-period-duration-of-the-proposed-trial`]:
                    licenceDetails?.trialInformation?.dateAndPeriodDurationOfTheProposedTrial ?? '-',
                [`${TRIAL_INFORMATION}-describe-the-role-identity-and-numbers-of-involved-parties`]:
                    licenceDetails?.trialInformation?.describeTheRoleIdentityAndNumberOfInvolvedParties ?? '-',
                [`${TRIAL_INFORMATION}-describe-the-scope-and-feature-with-the-technical-commercial-parameters`]:
                    licenceDetails?.trialInformation?.describeTheScopeAndFeatureWithTheTechnicalCommercialParameters ?? '-',
                [`${TRIAL_INFORMATION}-provide-the-system-configuration-that-will-be-used`]:
                    licenceDetails?.trialInformation?.provideTheSystemConfigurationThatWillBeUsed ?? '-',
                [`${TRIAL_INFORMATION}-provide-the-location-and-geographic-coverage`]:
                    licenceDetails?.trialInformation?.provideTheLocationAndGeographicCoverage ?? '-',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    return licence;
};

const tfApplicationPayload = {
    formatTFApplication
};

export default tfApplicationPayload;
